export const getSearchParams = (search) => {
  const searchParams = new URLSearchParams(search);

  return searchParams.toString();
};

export const getSearchParam = (search, param) => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(param);
};

export const setSearchParam = (search, param, value) => {
  const searchParams = new URLSearchParams(search);

  Boolean(value) ? searchParams.set(param, value) : searchParams.delete(param);

  return searchParams.toString();
};

export const getSearchParamsObj = (search, filtersData) => {
  const obj = {};

  const searchParams = new URLSearchParams(search);

  if (searchParams.toString()) {
    for (const [key, value] of searchParams.entries()) {
      const hasDeserialize = typeof filtersData[key].deserialize === 'function';

      obj[key] = hasDeserialize ? filtersData[key].deserialize(value) : value;
    }
  }

  return obj;
};
